module.exports = __webpack_public_path__ + "img/diplomat.50874abf.png";